export enum Role {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  TENANT = 'TENANT',
  TECHNICIAN = 'TECHNICIAN',
  MONITORING = 'MONITORING'
}

export enum HemisphereLevel {
  OWNER = 'Owner',
  MANAGER = 'Manager',
  OCCUPANT = 'Occupant'
}

export enum HemisLevel {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  ADVANCED = 'ADVANCED',
  BASIC = 'BASIC',
  MONITORING = 'MONITORING'
}

export function getRoleFromAuthorizationLevels(hemisphereLevel: string, hemisLevel: string): Role {
  if (hemisLevel == HemisLevel.OWNER) {
    return Role.OWNER
  }
  if (hemisLevel == HemisLevel.ADMIN) {
    return Role.ADMIN
  }
  if (hemisphereLevel == HemisphereLevel.OCCUPANT && (hemisLevel == HemisLevel.ADVANCED || hemisLevel == HemisLevel.BASIC)) {
    return Role.TENANT
  }
  if (hemisphereLevel != HemisphereLevel.OCCUPANT && hemisLevel == HemisLevel.ADVANCED) {
    return Role.TECHNICIAN
  }
  return Role.MONITORING
}

export function getAllowedRoleGrant(role: Role): Role[] {
  switch (role) {
    case Role.OWNER:
    case Role.ADMIN:
      return [Role.ADMIN, Role.TENANT, Role.TECHNICIAN, Role.MONITORING]
    case Role.TENANT:
      return [Role.TECHNICIAN, Role.MONITORING]
    case Role.TECHNICIAN:
      return [Role.TECHNICIAN]
    case Role.MONITORING:
      return [Role.MONITORING]
  }
}

export function getHemisLevelFromRole(role: string): string {
  switch (role) {
    case Role.OWNER:
      return HemisLevel.OWNER
    case Role.ADMIN:
      return HemisLevel.ADMIN
    case Role.TENANT:
      return HemisLevel.BASIC
    case Role.TECHNICIAN:
      return HemisLevel.ADVANCED
    case Role.MONITORING:
      return HemisLevel.MONITORING
    default:
      return HemisLevel.MONITORING
  }
}
